"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _polished = require("polished");

var _styledComponents = require("styled-components");

var _color = _interopRequireDefault(require("../choices/color.const"));

var _size = _interopRequireDefault(require("../choices/size.const"));

var _spacing = _interopRequireDefault(require("../choices/spacing.const"));

var _timing = _interopRequireDefault(require("../choices/timing.const"));

var _zIndex = _interopRequireDefault(require("../choices/zIndex.const"));

var _font = _interopRequireDefault(require("../choices/font.const"));

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var animation = (0, _styledComponents.keyframes)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  70% {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n"])));
var fadeInAnimation = (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  animation: ", " ", " ease-in;\n"])), animation, _timing["default"].medium);
var modal = {
  zIndex: _zIndex["default"].z2000,
  widthSmall: '620px',
  widthLarge: '960px',
  minHeight: '360px',
  maxHeight: '600px',
  backgroundColor: _color["default"].white,
  shadowSize: _size["default"].shadowMedium,
  shadowColor: (0, _polished.rgba)(_color["default"].pickledBluewood800, 0.1),
  borderRadius: _size["default"].borderRadiusMedium,
  animation: fadeInAnimation,
  headerPadding: _spacing["default"].md,
  headerPaddingRightWithIcon: '56px',
  headerShadowSize: _size["default"].shadowSmall,
  headerShadowColor: _color["default"].cloudyBlue300,
  headerFontFamily: _font["default"].family,
  headerTitleFontSize: _font["default"].sizeLg,
  headerTitleLineHeight: _font["default"].lineHeightLg,
  headerTitleFontWeight: _font["default"].weightAttention,
  headerIconTop: _spacing["default"].md,
  headerIconRight: _spacing["default"].md,
  footerPaddingHorizontal: _size["default"].medium,
  footerPaddingSmallHorizontal: _size["default"].default2x,
  footerPaddingVertical: _size["default"].default2x,
  footerShadowSize: _size["default"].shadowSmall,
  footerShadowColor: _color["default"].cloudyBlue300,
  footerButtonSpacing: _spacing["default"].md
};
var _default = modal;
exports["default"] = _default;